import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../css/Header.css";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  return (
    <header className="App-header">
      <div className="navbar">
        <div className="navbar-left">
          <div className="navbar-logo">
            <Link to="/">Soul_Mate</Link>
          </div>
        </div>

        {/* 햄버거 메뉴 아이콘 */}
        <div className="hamburger" onClick={toggleMenu}>
          <div></div>
          <div></div>
          <div></div>
        </div>

        {/* 토글되는 메뉴 */}
        <ul className={`navbar-menu ${isOpen ? "active" : ""}`}>
          <li>
            <Link to="/">메인</Link>
          </li>
          <li>
            <Link to="/Community">커뮤니티</Link>
          </li>
          <li>
            <Link to="/Affiliate">제휴사</Link>
          </li>
          <li>
            <Link to="/support">지원</Link>
          </li>
          <li>
            <Link to="/contact">문의하기</Link>
          </li>
        </ul>
      </div>
    </header>
  );
};

export default Header;
